module.exports = __webpack_public_path__ + "static/media/icon_126.cc1bd15c.svg";